import { render, staticRenderFns } from "./IssueMap.vue?vue&type=template&id=e23bddf0&scoped=true&"
import script from "./IssueMap.vue?vue&type=script&lang=js&"
export * from "./IssueMap.vue?vue&type=script&lang=js&"
import style0 from "./IssueMap.vue?vue&type=style&index=0&id=e23bddf0&scoped=true&lang=css&"
import style1 from "./IssueMap.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23bddf0",
  null
  
)

export default component.exports